<template>
  <transition name="el-fade-in-linear">
    <div
      v-show="dialogVisible"
      class="popContainer indiv-pop indiv-pop--top"
    >
      <div class="indiv-pop-center">
        <span
          class="indiv-pop-close iconfont icon-close_round_fill_bold"
          role="button"
          aria-label="关闭"
          @click="onClose"
        ></span>
        <div class="indiv-pop-box">
          <div class="indiv-pop-title">实名认证</div>
          <div class="indiv-pop-body">
            <el-form
              ref="realnameForm"
              :model="form"
              :rules="formRules"
              label-width="120px"
              label-position="right"
              @submit.native.prevent
            >
              <el-form-item label="手机号" prop="phone">
                <el-input
                  v-model="form.phone"
                  placeholder="请输入手机号"
                  maxlength="11"
                />
              </el-form-item>
              <el-form-item label="真实姓名" prop="realName">
                <el-input
                  v-model="form.realName"
                  placeholder="请输入真实姓名"
                  maxlength="20"
                />
              </el-form-item>
              <el-form-item label="身份证号" prop="idCard">
                <el-input
                  v-model="form.idCard"
                  placeholder="请输入身份证号码"
                  maxlength="18"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="indiv-pop-foot">
            <button
              type="button"
              class="indiv-pop-btn"
              :disabled="submitting"
              @click.prevent="onSubmit"
            >
              {{ submitting ? "提交中..." : "提交" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  isRealnameVerified,
  realnameState,
  verifyRealname,
} from "./realnameService";
import { refreshIndivSession } from "../indivSession/indivSessionService";

const ID_CARD_PATTERN = /^\d{17}[\dXx]$/;
const PHONE_PATTERN = /^1\d{10}$/;

export default {
  name: "RealnameDialog",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      submitting: false,
      form: {
        phone: "",
        realName: "",
        idCard: "",
      },
      formRules: {
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "真实姓名长度应在2-20个字符之间",
            trigger: "blur",
          },
        ],
        idCard: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const raw = String(value || "").trim();
              if (!raw) {
                callback(new Error("请输入身份证号码"));
                return;
              }
              if (raw.length !== 18 || !ID_CARD_PATTERN.test(raw)) {
                callback(new Error("身份证号码应为18位"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const raw = String(value || "").trim();
              if (!raw) {
                callback(new Error("请输入手机号"));
                return;
              }
              if (!PHONE_PATTERN.test(raw)) {
                callback(new Error("手机号格式不正确"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    registeredPhone() {
      const u = this.$store.state.usermsg;
      if (u && typeof u === "object" && u.phone != null) {
        return String(u.phone).trim();
      }
      return "";
    },
  },

  watch: {
    visible(val) {
      if (val) {
        this.onOpen();
      }
    },
  },

  methods: {
    /** 打开弹窗：已实名则提示并关闭 */
    onOpen() {
      if (realnameState.loaded && isRealnameVerified(realnameState.status)) {
        this.$message.info("您已完成实名认证，无需重复认证");
        this.dialogVisible = false;
        return;
      }

      this.form = {
        phone: this.registeredPhone,
        realName: "",
        idCard: "",
      };
      this.submitting = false;
      this.$nextTick(() => {
        if (this.$refs.realnameForm) {
          this.$refs.realnameForm.clearValidate();
        }
      });
    },

    /** 关闭弹窗（提交中不可关） */
    onClose() {
      if (this.submitting) {
        return;
      }
      this.dialogVisible = false;
      this.$emit("close");
    },

    /** 提交三要素核验，成功后刷新 indiv 会话 */
    onSubmit() {
      if (this.submitting) {
        return;
      }

      this.$refs.realnameForm.validate((valid) => {
        if (!valid) {
          return;
        }

        this.submitting = true;
        const payload = {
          realName: String(this.form.realName).trim(),
          idCard: String(this.form.idCard).trim().toUpperCase(),
          phone: String(this.form.phone).trim(),
        };

        verifyRealname(payload)
          .then((result) => {
            return refreshIndivSession({
              force: true,
              store: this.$store,
            }).then(() => result);
          })
          .then((result) => {
            this.$message.success("实名认证成功");
            this.dialogVisible = false;
            this.$emit("success", result);
          })
          .catch((err) => {
            this.$message.error(
              (err && err.message) ||
                "三要素核验未通过，请确认姓名与身份证号是否与注册手机号一致"
            );
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/user/realname/RealnameDialog.vue